import { IHttpResponse } from 'app_types/httpTypes'
import { IAttachedCategory } from './admin/attachedCategory/attachedCategory.types'
import { IRoleListItem } from './admin/role/roleTypes';
import { INewCourseSchedulingEnrollment } from 'app_types/admin/courseScheduling/courseSchedulingEnrollmentTypes';

export enum UserHome {
  ADMIN = 'admin',
  STUDENT = 'student',
  TEACHER = 'teacher',
  ACCOUNT_EXECUTIVE = 'account_executive',
  COMPANY = 'company',
}

export type TypesQuestionCategories = 'select-range' | 'container' | 'multiple-choice-unique-answer' | 'multiple-choice-multiple-answer' | 'open-answer'
export type TypeAcademicResourceCategories = 'survey'
export type TypeAcademicResourceConfigCategories = 'survey'

export type TypeRolesUser = 'admin' | 'student' | 'company' | 'viewer' | 'logistics_assistant' | 'scheduling_coordinator' | 'teacher' | 'account_executive'

export interface IUserPermissions {
  [keys: string]: string[]
}

export interface IUserProfile {
  first_name: string
  last_name: string
  doc_type: string
  doc_number: string
}

export interface IUserData {
  id?: string
  _id?: string
  username: string
  profile: IUserProfile
  permissions?: IUserPermissions
  screen_mode?: string
  password?: string
  confirm_password?: string
  roles?: Array<IRoleListItem>
  styles: IStyleScreen[]
  email?: string
  moodle?: {username: string, password: string, moodle_id: string}
  admin_company?: boolean
  home?: {
    name: UserHome
  }
  // Interacciones
  show_profile_interaction: boolean,
  passwordUpdated?: boolean
  reviewData?: {
    status: 'pending' | 'reviewed'
    lastReview: Date
  }
  email?: string
}

export interface IStyleScreen {
  _id: string
  type: 'light_theme' | 'dark_theme' | 'classes'
  name: string
  styles: string
}

export interface IUser {
  data?: IUserData
  timestamp?: number
  token?: string
  locale?: string
  questionCategories?: IQuestionCategory[]
  academicResourceCategories?: IAcademicResourceCategory[]
  academicResourceConfigCategories?: IAcademicResourceConfigCategory[]
  attachedCategories?: IAttachedCategory[]
  selfRegisterEnrollments?: INewCourseSchedulingEnrollment[]
}

export interface IUserHttpResponse extends IHttpResponse {
  user: IUserData
  token: string
  locale?: string
  questionCategories?: IQuestionCategory[]
  academicResourceCategories?: IAcademicResourceCategory[]
  academicResourceConfigCategories?: IAcademicResourceConfigCategory[]
  attachedCategories?: IAttachedCategory[]
  selfRegisterEnrollments?: INewCourseSchedulingEnrollment[]
  check2fa?: boolean
}

export interface IPasswordRecoveryFromSource {
  destination: 'email' | 'sms'
  email?: string
  cell_phone?: string
}
export interface IChangeRecoveredPassword {
  token: string
  password: string
}

/**
 * @INFO Interfaces de categorías de recursos académicos
 */
 interface IConfigAcademicResourceCategory {
  statistics?: {
    has_completed_status?: boolean,
    has_velocity_index?: boolean,
    has_completitud_index?: boolean,
    has_skill_index?: boolean,
    has_persistence_index?: boolean,
    has_effort_index?: boolean,
    has_efficiency_index?: boolean,
    has_learning_index?: boolean,
    has_note_index?: boolean,
  }
  has_complementary_resources?: boolean,
  has_questions?: boolean,
  has_lessons_related?: boolean,
  has_game_algorithm?: boolean,
}

export interface IAcademicResourceCategory {
  _id: string
  name: TypeAcademicResourceCategories
  description: string
  config?: IConfigAcademicResourceCategory
}

export interface IAcademicResourceConfigCategory{
  config: {
    has_order_of_questions: boolean
  }
  _id: string
  name: string
  description: string
}

/**
 * @INFO Interfaces para las categorías de preguntas
 */
export interface IQuestionCategory {
  config: {
    has_order_of_answers: boolean,
  },
  _id: string,
  name: TypesQuestionCategories,
  description: string
}

export type UserFormInputs = UserFormGeneralInfoInputs | UserFormAvatarInputs | UserFormSecurityInputs

export enum UserFormSections {
  AVATAR = 'avatar',
  GENERAL_INFO = 'general_info',
  SECURITY = 'security'
}

export enum UserFormGeneralInfoInputs {
  FIRST_NAME = 'first_name',
  LAST_NAME = 'last_name',
  PHONE_NUMBER = 'phone_number',
  EMAIL = 'email',
  TIMEZONE = 'timezone',
  CULTURE = 'culture',
}

export enum UserFormAvatarInputs {
  AVATAR = 'avatar'
}

export enum UserFormSecurityInputs {
  PASSWORD = 'password'
}
